import { createContext } from 'ui/lib/react-utils'

export type FooterContextState = {
  contrastColorTheme?: 'dark' | 'light'
}

export const [FooterContextProvider, useFooterContext] = createContext<FooterContextState>({
  strict: false,
  initialValue: { contrastColorTheme: 'dark' }
})
